import {
  Box,
  Divider,
  Flex,
  Button,
  Icon,
  Heading,
  HStack,
  Spinner,
  useToast,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { RiAddLine, RiMailSettingsLine } from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import ReactTableComponent from '../../components/TableComponent';
import api from '../../service/api';
import { getColumn } from '../../utils/getParamsColumn';
import { useHistory, useParams } from 'react-router-dom';
import { SiderbarResponsive } from '../../components/SiderbarResponsive';
import { Wapper } from '../../components/Wapper';
import { useAuth } from '../../context/AuthContext';
import { ExcludeDialog } from '../../components/ExlcudeDialog';
import { ConfiguracaoEmailModal } from '../../components/ConfiguracaoEmailModal';

export default function ListParams() {
  type IParams = {
    id: string;
  };

  const { user } = useAuth();

  const [parametros, setParametros] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [idToDelete, setIdToDelete] = useState('');
  const [configurandoEmail, setConfigurandoEmail] = useState(false);

  const toast = useToast();
  const history = useHistory();

  const params = useParams<IParams>();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const id = params.id;

  function handleDelete(id: any) {
    setIdToDelete(id);
    onOpen();
  }

  const handleUpdate = async (e: any, id: string) => {
    try {
      await api.post(
        // `/api-essencial/v1/parametrizacao/update-excluido/${id}`,
        `/api-essencial/v1/parametrizacao/${user.empresa.id}`
        // {
        //   excluido: true,
        // }
      );

      const response = await api.get(
        `/api-essencial/v1/parametrizacao/${user.empresa.id}`
      );

      setParametros(response.data);

      toast({
        title: 'Parametrizacao deletada com sucesso',
        description: ``,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      history.push('/listar/parametrizacao');
    } catch (error) {
      if (parametros) {
        toast({
          title: 'Parametrizacao deletada com sucesso',
          description: ``,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setParametros([]);
      }
    }
  };

  // "Cadastrar" (botão acima) leva pro cadastro de uma empresa nova
  // (/cadastro/parametrizacao); o lápis de cada linha continua editando as
  // regras de negócio desta lista.
  const column = getColumn(handleDelete, '/edit/regras-parametrizacao');

  useEffect(() => {
    // if (user.empresa.id == "1" && user.role == "ROLE_ADMIN") {
    //   api.get(`/api-essencial/v1/categorias/`).then((response) => {
    //     setCategories(response.data.data);
    //   });
    // }

    // Lista TODAS as empresas/filiais (GET /empresas), não só a do usuário
    // logado — antes essa tela usava /parametrizacao/:id (escopado a uma
    // única empresa) e por isso nunca mostrava filiais recém-cadastradas.
    api
      .get('/empresas')
      .then((response) => {
        setParametros(response.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, [user.empresa.id]);

  return (
    <>
      <Header />
      <SiderbarResponsive />

      <Flex align="start" mx="auto" mt="8" px="6">
        <Wapper>
          <Box flex="1" p="8" bg="gray.800" borderRadius={8} mb="16">
            <Flex justify="space-between" align="center">
              <Heading size="md" fontWeight="normal">
                CADASTRO DE EMPRESAS
              </Heading>
              <HStack spacing="3">
                <Button
                  size="sm"
                  fontSize="sm"
                  variant="outline"
                  colorScheme="orange"
                  leftIcon={<Icon as={RiMailSettingsLine} />}
                  onClick={() => setConfigurandoEmail(true)}
                >
                  Configurar e-mail
                </Button>
                <Button
                  as="a"
                  size="sm"
                  fontSize="sm"
                  colorScheme="orange"
                  leftIcon={<Icon as={RiAddLine} />}
                  cursor="pointer"
                  onClick={() => history.push('/cadastro/parametrizacao')}
                >
                  Cadastrar Empresa
                </Button>
              </HStack>
            </Flex>

            <Divider my="6" borderColor="gray.700" />

            <Flex justifyContent="center">
              {isLoading ? (
                <Spinner color="white" />
              ) : (
                <>
                  {!parametros || parametros.length === 0 ? (
                    <Flex>
                      <Text color="orange.200">Sem parametros para exibir</Text>
                    </Flex>
                  ) : (
                    <ReactTableComponent
                      columns={column}
                      data={parametros}
                      isPagenable
                      showFilter={false}
                    />
                  )}
                </>
              )}
            </Flex>
          </Box>
        </Wapper>
      </Flex>
      {configurandoEmail && (
        <ConfiguracaoEmailModal
          empresas={parametros || []}
          onClose={() => setConfigurandoEmail(false)}
        />
      )}
      <ExcludeDialog
        isOpen={isOpen}
        onClose={onClose}
        label="parametros"
        deleteFunction={(e) => {
          handleUpdate(e, idToDelete);
          onClose();
        }}
      />
    </>
  );
}
